import React from 'react'
import PropTypes from 'prop-types'
import ComponentLink from './Link'

const Link = ({ text, href, className, block = false }) => (
  <ComponentLink className={`focus:outline-none group ${block ? 'w-full' : 'inline-flex'}`} href={href}>
    < p className={`${className} group-focus:text-primary group-hover:underline`}>{text}</p>
  </ComponentLink >
)

Link.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  block: PropTypes.bool,
}

const Button = ({ text, onClick, className }) => (
  <button type="button" className={`${className} inline-flex cursor-pointer focus:outline-none focus:text-primary hover:underline`} onClick={onClick}>{text}</button>
)

Link.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  block: PropTypes.bool,
}

Button.propTypes = {
  text: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default {
  Link,
  Button,
}
